module.exports = __webpack_public_path__ + "static/img/box.da3248f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/box.png
// module id = ySZc
// module chunks = 1